export { default } from './EducationCardsModal';



// WEBPACK FOOTER //
// ./src/sections/EducationCards/index.ts